<script>
import Layout from "@/layouts/layout";
import { mapState } from "vuex";
import moment from "moment";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { STATUS_CODES } from "@/utils/api/apiConstants";
import { getDayNameVietnamese } from "@/utils/time/dateUtils";

import Banner from "./components/Banner.vue";
import SiteInfo from "./components/SiteInfo.vue";
import SanPhamTieuBieu from "./components/SanPhamTieuBieu.vue";
import LichHoatDong from "./components/LichHoatDong.vue";
import TinTucMoiNhat from "./components/TinTucMoiNhat.vue";

export default {
  name: "Home",
  components: {
    Layout,
    Banner,
    SiteInfo,
    SanPhamTieuBieu,
    LichHoatDong
  },
  data() {
    return {
      apiView: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      url: `${process.env.VUE_APP_API_URL}filesminio/view`,
      totalRows: 1,
      perPage: 12,
      currentPage: 1,
      hoa: [],
      sharedPosts: [],
      getDayNameVietnamese: getDayNameVietnamese,
      ongoingActivities: [],
      dailyPrograms: [],
      mainActivities: [],
      supportActivities: [],
    };
  },
  computed: {
    ...mapState("authStore", ["token"]),
  },
  created() {
    this.getTraiCay(false);
    this.getNewsFeatures();
    this.getAllSuKien();
  },
  watch: {
    perPage() {
      this.getTraiCay();
    },
    currentPage() {
      this.getTraiCay(true);
    },
  },
  methods: {
    async getNewsFeatures() {
      let params = { start: 1, limit: 32, isPublic: true };
      await this.$store
        .dispatch("profession/tinTuc/tinTucStore/getPagingParams", params)
        .then((res) => {
          this.sharedPosts = res && res.data ? res.data.data : [];
        });
    },
    groupActivitiesByDate(activitiesFlat) {
      if (!activitiesFlat || activitiesFlat.length === 0) return [];
      const grouped = {};
      activitiesFlat.forEach((activity) => {
        const dateString = activity.ngayBatDau;
        if (!dateString) return;
        const dateKey = moment(dateString).format("DD/MM");
        if (!grouped[dateKey]) {
          grouped[dateKey] = {
            sortKey: dateString,
            date: dateKey,
            dayName: this.getDayNameVietnamese(
              moment(dateString).format("dddd")
            ),
            events: [],
          };
        }
        grouped[dateKey].events.push({ ...activity, id: activity._id });
      });
      return Object.values(grouped).sort(
        (a, b) => new Date(a.sortKey) - new Date(b.sortKey)
      );
    },
    async getAllSuKien() {
      this.ongoingActivities = [];
      this.dailyPrograms = [];
      this.mainActivities = [];
      this.supportActivities = [];
      await this.$store
        .dispatch("profession/chuongTrinh/chuongTrinhStore/getAll")
        .then((res) => {
          if (res?.data && STATUS_CODES.SUCCESS_VALUES.includes(res.code)) {
            let dailyProgramsFlat = [];
            res.data.forEach((cat) => {
              if (cat.hoatDongXuyenSuot)
                this.ongoingActivities = [
                  ...this.ongoingActivities,
                  ...cat.hoatDongXuyenSuot,
                ];
              if (cat.hoatDongTheoKhungSo)
                dailyProgramsFlat = [
                  ...dailyProgramsFlat,
                  ...cat.hoatDongTheoKhungSo,
                ];
              const mainAct = cat.truocLeHoi || cat.hoatDongChinh;
              if (mainAct)
                this.mainActivities = [...this.mainActivities, ...mainAct];
              if (cat.hoatDongHuongUng)
                this.supportActivities = [...this.supportActivities, ...cat.hoatDongHuongUng];
            });
            this.dailyPrograms = this.groupActivitiesByDate(dailyProgramsFlat);
          }
        });
    },
    async getTraiCay(shouldScroll = true) {
      const params = {
        start: this.currentPage,
        limit: this.perPage,
        sortBy: "Sort",
        sortDesc: true,
      };
      await this.$store
        .dispatch("profession/traiCay/traiCayStore/getPagingParams", params)
        .then((res) => {
          if (res) {
            this.hoa = res.data.data;
            this.totalRows = res.data.totalRows;
            if (shouldScroll) this.scrollToTop();
          }
        });
    },
    nextSlide() {
      this.$refs.listCarousel.next();
    },
    prevSlide() {
      this.$refs.listCarousel.prev();
    },
    scrollToTop() {
      this.$nextTick(() => {
        if (this.$refs.hoaListContainer)
          this.$refs.hoaListContainer.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
      });
    },
  },
};
</script>

<template>
  <Layout>
    <section class="home-page-wrapper font-body-premium" id="home">
      <!-- MỚI: Header Banner (Hero Section) -->
      <Banner />

      <!-- Main Content Area: Sử dụng các component mới -->
      <SiteInfo />
      <SanPhamTieuBieu />
      <LichHoatDong :ongoing-activities="ongoingActivities" :daily-programs="dailyPrograms"
        :main-activities="mainActivities" :support-activities="supportActivities" />
      <!-- <TinTucMoiNhat /> -->
    </section>
  </Layout>
</template>


<style scoped>
/* ======================== I. HỆ THỐNG KHOẢNG CÁCH ĐỐI XỨNG ======================== */
.home-page-wrapper {
  width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  background-color: var(--color-public-bg);
}

.main-content-full {
  width: 100%;
  padding: 0;
}

.widget-section {
  position: relative;
  width: 100%;
  padding-top: var(--spacing-margin-desktop);
  padding-bottom: var(--spacing-margin-desktop);
}

.main-content-container,
.widget-padding-contain,
.section-title-wrapper {
  max-width: var(--container-max);
  margin: 0 auto;
  padding-left: var(--spacing-gutter) !important;
  padding-right: var(--spacing-gutter) !important;
}

.section-title-new {
  font-size: var(--text-headline-md-size);
  font-weight: 800;
  color: var(--color-public-text-head);
}

.section-subtitle {
  font-size: var(--text-body-lg-size);
  color: var(--color-public-text-body);
  margin-top: var(--spacing-unit);
}

@media (max-width: 768px) {
  .widget-section {
    padding-top: var(--spacing-margin-mobile);
    padding-bottom: var(--spacing-margin-mobile);
  }
}

/* ======================== II. TRANG TRÍ & TIỆN ÍCH ======================== */

.widget-section {
  position: relative;
  width: 100%;
}

.bg-light-section {
  background-color: var(--color-public-surface);
  border-top: 1px solid var(--surface-dim);
  border-bottom: 1px solid var(--surface-dim);
}

.main-content-container {
  padding: 0 !important;
}

.section-title-wrapper {
  text-align: center;
  margin-bottom: var(--spacing-margin-desktop);
}

@media (max-width: 768px) {
  .section-title-wrapper {
    margin-bottom: var(--spacing-margin-mobile);
  }
}

.highlight-underline {
  color: var(--color-public-primary);
  border-bottom: 4px solid var(--color-public-secondary);
}

/* ======================== III. ĐỒNG BỘ CÁC COMPONENT ======================== */
.hoa-grid-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  width: 100%;
}

.row-carousel-relative {
  position: relative;
  width: 100%;
}

.banner-full-width {
  width: 100%;
}

.carousel-nav-btn {
  width: 40px;
  height: 40px;
  background-color: #f4f4f461 !important;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
  z-index: 10;
  display: flex !important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: 1px solid #eee !important;

  color: #333;
  /* Màu mặc định của icon mũi tên */
  font-family: "slick";
  font-size: 1.3rem;
  font-weight: 700;
  opacity: 0.8;
  /* position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: white;
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease; */
}

.carousel-nav-btn.prev {
  left: 0px;
  /* Căn sát lề trái container */
  transform: translateY(-50%) translateX(-110%);
  /* ĐẨY NÚT RA NGOÀI CONTAINER 1/2 WIDTH */
}

.carousel-nav-btn.next {
  right: 0px;
  /* Căn sát lề phải container */
  transform: translateY(-50%) translateX(110%);
  /* ĐẨY NÚT RA NGOÀI CONTAINER 1/2 WIDTH */
}

.carousel-nav-btn.next:hover {
  background: var(--color-primary, #082957) !important;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
  color: #fff;
}

.carousel-nav-btn.prev:hover {
  background: var(--color-primary, #082957) !important;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
  color: #fff;
}

@media (max-width: 1024px) {
  .carousel-nav-btn {
    display: none !important;
  }

  .hoa-grid-container {
    gap: 20px;
  }
}
</style>
